import { Controller } from "@hotwired/stimulus"

// Lazy player facade — swaps the cover/play button for the streaming embed
// iframe on first interaction. The iframe never appears in the initial HTML, so
// the heavy Spotify/YouTube embed can't hurt LCP. Generic over the embed URL.
//
// Expected markup:
//   <div data-controller="playlist-embed"
//        data-playlist-embed-src-value="https://open.spotify.com/embed/playlist/ID"
//        data-playlist-embed-title-value="Rainy Day Bossa Nova">
//     <button data-playlist-embed-target="facade" data-action="playlist-embed#load">…</button>
//   </div>
export default class extends Controller {
  static targets = ["facade"]
  static values = { src: String, title: String }

  load() {
    if (!this.srcValue || !this.hasFacadeTarget) return

    const iframe = document.createElement("iframe")
    iframe.src = this.srcValue
    iframe.title = this.titleValue || "Player"
    iframe.loading = "lazy"
    iframe.setAttribute(
      "allow",
      "autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
    )
    iframe.setAttribute("allowfullscreen", "")
    iframe.classList.add("pl-facade__embed")

    this.facadeTarget.replaceWith(iframe)
  }
}
